function Rtn(e){switch(e){case`active`:return`paused`;case`paused`:case`blocked`:case`usageLimited`:return`active`;case`budgetLimited`:case`complete`:return null}}
export { Rtn as desktopGoalStatusAction };
